module.exports = __webpack_public_path__ + "img/banner_desktop.a2bf2aad.png";